import {PostInvoicesRecoverParams} from 'domain/usecases';
import {makePostInvoicesRecover} from 'main/factories/usecases/private/my-payments-flow/remote-my-payments/post-invoices-recover';

export async function postInvoicesRecover(params: PostInvoicesRecoverParams) {
	const response = await makePostInvoicesRecover().post({
		...params,
		signal: new AbortController().signal,
	});

	return response;
}
